var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2005 5.51855L10.4899 4.81501L11.2005 4.09718L11.9112 4.81501L11.2005 5.51855ZM12.2005 13.8519C12.2005 14.4042 11.7528 14.8519 11.2005 14.8519C10.6482 14.8519 10.2005 14.4042 10.2005 13.8519L12.2005 13.8519ZM5.90654 9.44464L10.4899 4.81501L11.9112 6.2221L7.32784 10.8517L5.90654 9.44464ZM11.9112 4.81501L16.4945 9.44464L15.0732 10.8517L10.4899 6.2221L11.9112 4.81501ZM12.2005 5.51855L12.2005 13.8519L10.2005 13.8519L10.2005 5.51855L12.2005 5.51855Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 15.7031L4.78125 16.6291C4.78125 17.6518 5.60206 18.4809 6.61458 18.4809L15.7812 18.4809C16.7938 18.4809 17.6146 17.6518 17.6146 16.6291V15.7031",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.ae409ee6861542cb4a3e3952a90721ea.svg";
export { ForwardRef as ReactComponent };